import React, { Component } from 'react';
import Item from './Item';
import ShowMoreButton from '../common/ShowMoreButton';

class OrganizationsList extends Component {
  render() {
    let organizations = [];
    const category = parseInt(this.props.category);
    const list_header = this.props.listHeader ? this.props.listHeader : 'Alle trossamfund og menigheder';
    const filter = this.props.filter;
    const searchString = this.props.searchString;
    const page = this.props.page;
    const itemsPerPage = 10;
    let itemsToShow = page * itemsPerPage;

    if(filter) {
      this.props.organizationsFromAPI.forEach((unit, index) => {
        if(filter==="new_donations") {
          if(unit.new_donations === 1 || unit.new_annual_reports === 1) {
            organizations.push(<Item information={unit} key={unit.id} children={unit.children} />);
          } 
        } else {
          if(unit[filter] === 1) {
            organizations.push(<Item information={unit} key={unit.id} children={unit.children} />);
          }
        }         
      });
    } else {

    this.props.organizationsFromAPI.forEach((unit, index) => {
      if((unit.category_id === category || isNaN(category)) &&
          (unit.name.toLowerCase().indexOf(searchString.toLowerCase()) >= 0 ||
            unit.vat_number.toLowerCase().indexOf(searchString.toLowerCase()) >= 0 ||
              unit.address.toLowerCase().indexOf(searchString.toLowerCase()) >= 0 ||
                unit.contact_name.toLowerCase().indexOf(searchString.toLowerCase()) >= 0 ||
                  unit.contact_email.toLowerCase().indexOf(searchString.toLowerCase()) >= 0)) {
                    organizations.push(<Item information={unit} key={unit.id} children={unit.children} />);
                }
      });
    }

    return (
      <div className="OrganizationsList">
        <h5>{list_header}</h5>
        {organizations.slice(0, itemsToShow)}
        {organizations.length>organizations.slice(0, itemsToShow).length && <ShowMoreButton showMore={this.props.showMore} />}
      </div>
    );
  }
}

export default OrganizationsList;


// WEBPACK FOOTER //
// ./src/modules/organization/List.js